const currencyFormatters = new Map();

const formatCurrencyValue = (value, locale = 'el-GR') => {
  const isObject = typeof value === 'object' && value !== null;
  const number = isObject ? value?.number : value;
  if (!number) {
    return '-';
  }

  const currency = (isObject ? value?.currency : null) || 'EUR';
  const cacheKey = `${locale}-${currency}`;
  let formatter = currencyFormatters.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    });
    currencyFormatters.set(cacheKey, formatter);
  }

  return formatter.format(number);
};

export default formatCurrencyValue;
